const usPrefixRanges: ReadonlyArray<readonly [number, number, string]> = [
    [5, 5, 'America/New_York'],
    [6, 9, 'America/Puerto_Rico'],
    [10, 99, 'America/New_York'],
    [100, 199, 'America/New_York'],
    [200, 299, 'America/New_York'],
    [300, 319, 'America/New_York'],
    [320, 324, 'America/New_York'],
    [325, 325, 'America/Chicago'],
    [326, 349, 'America/New_York'],
    [350, 369, 'America/Chicago'],
    [370, 375, 'America/Chicago'],
    [376, 379, 'America/New_York'],
    [380, 397, 'America/Chicago'],
    [398, 399, 'America/New_York'],
    [400, 418, 'America/New_York'],
    [420, 427, 'America/Chicago'],
    [430, 459, 'America/New_York'],
    [460, 475, 'America/Indiana/Indianapolis'],
    [476, 477, 'America/Chicago'],
    [478, 479, 'America/Indiana/Indianapolis'],
    [480, 499, 'America/Detroit'],
    [500, 528, 'America/Chicago'],
    [530, 549, 'America/Chicago'],
    [550, 567, 'America/Chicago'],
    [570, 576, 'America/Chicago'],
    [577, 577, 'America/Denver'],
    [580, 587, 'America/Chicago'],
    [588, 588, 'America/Denver'],
    [590, 599, 'America/Denver'],
    [600, 629, 'America/Chicago'],
    [630, 658, 'America/Chicago'],
    [660, 676, 'America/Chicago'],
    [677, 677, 'America/Denver'],
    [678, 679, 'America/Chicago'],
    [680, 692, 'America/Chicago'],
    [693, 693, 'America/Denver'],
    [700, 714, 'America/Chicago'],
    [716, 729, 'America/Chicago'],
    [730, 749, 'America/Chicago'],
    [750, 798, 'America/Chicago'],
    [799, 799, 'America/Denver'],
    [800, 816, 'America/Denver'],
    [820, 831, 'America/Denver'],
    [832, 837, 'America/Denver'],
    [838, 838, 'America/Los_Angeles'],
    [840, 847, 'America/Denver'],
    [850, 865, 'America/Phoenix'],
    [870, 884, 'America/Denver'],
    [889, 898, 'America/Los_Angeles'],
    [900, 961, 'America/Los_Angeles'],
    [967, 968, 'Pacific/Honolulu'],
    [969, 969, 'Pacific/Guam'],
    [970, 979, 'America/Los_Angeles'],
    [980, 994, 'America/Los_Angeles'],
    [995, 999, 'America/Anchorage'],
];

const provinceToTimezone: Record<string, string> = {
    BC: 'America/Vancouver',
    AB: 'America/Edmonton',
    SK: 'America/Regina',
    MB: 'America/Winnipeg',
    ON: 'America/Toronto',
    QC: 'America/Toronto',
    NB: 'America/Moncton',
    NS: 'America/Halifax',
    PE: 'America/Halifax',
    NL: 'America/St_Johns',
    YT: 'America/Whitehorse',
    NT: 'America/Edmonton',
    NU: 'America/Iqaluit',
};

export function timezoneFromZipCode(zip: string): string | null {
    if (!zip || !/^\d{5}$/.test(zip)) {
        return null;
    }
    const prefix = parseInt(zip.slice(0, 3), 10);
    for (const [lo, hi, tz] of usPrefixRanges) {
        if (prefix >= lo && prefix <= hi) {
            return tz;
        }
    }
    return null;
}

export function timezoneFromCanadianProvince(provinceCode: string): string | null {
    if (!provinceCode) {
        return null;
    }
    return provinceToTimezone[provinceCode] ?? null;
}
